[
    {
        "key": "meals_time",
        "name": "お食事時間"
    },
    {
        "key": "pick_up",
        "name": "送迎"
    },
    {
        "key": "meals",
        "name": "お食事"
    },
    {
        "key": "dinner",
        "name": "夕食"
    },
    {
        "key": "breakfast",
        "name": "朝食"
    },
    {
        "key": "lunch",
        "name": "ランチ"
    },
    {
        "key": "drinks",
        "name": "お飲み物"
    },
    {
        "key": "restaurant_drinks",
        "name": "レストランドリンク"
    },
    {
        "key": "facilities",
        "name": "施設・設備"
    },
    {
        "key": "spa",
        "name": "スパ"
    },
    {
        "key": "activity",
        "name": "アクティビティ"
    },
    {
        "key": "bar",
        "name": "BAR"
    },
    {
        "key": "massage",
        "name": "マッサージ"
    },
    {
        "key": "dog",
        "name": "ワンちゃん"
    },
    {
        "key": "glamping",
        "name": "グランピング"
    },
    {
        "key": "room_service",
        "name": "ルームサービス"
    },
    {
        "key": "equipment_rental",
        "name": "備品貸出"
    },
    {
        "key": "bed_making",
        "name": "布団敷き"
    },
    {
        "key": "cleaning",
        "name": "清掃"
    },
    {
        "key": "souvenirs",
        "name": "お土産"
    },
    {
        "key": "anniversary",
        "name": "記念日"
    },
    {
        "key": "ticket",
        "name": "チケット"
    },
    {
        "key": "benefits",
        "name": "特典"
    },
    {
        "key": "upgrade",
        "name": "アップグレード"
    },
    {
        "key": "option",
        "name": "オプション"
    },
    {
        "key": "request",
        "name": "リクエスト"
    },
    {
        "key": "cancel",
        "name": "キャンセル"
    },
    {
        "key": "other",
        "name": "その他"
    }
]
